import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingService } from './setting.service';
import { Observable } from 'rxjs';

@Injectable()
export class CoachService {

  constructor(
    private settings: SettingService,
    private http: HttpClient
  ) {}

  api = 'school-program-http/api/v1';

  getCoachList(schoolLocationId: number): Observable<any[]> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/coach-list/' + schoolLocationId;
    // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/coach-list/' + schoolLocationId;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
}

  getCoachDetail(id: number): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/coach-detail/' + id;
    // const requestUrl = `http://localhost:3075/school-program-http/api/v1/coach-detail/${id}`;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
  }

  toggleDisableCoach(id: number, params: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/coach-disable/' + id;
    // const requestUrl = `http://localhost:3075/school-program-http/api/v1/coach-disable/${id}`;

    return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
  }

  addCoach(params: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/coach-add';
    // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/coach-add';

    return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
  }

  editCoach(params: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/coach-edit';
    // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/coach-edit';

    return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
  }

  deleteCoach(params: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/coach-delete';
    // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/coach-delete';

    return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
  }

  getReligionList(): Observable<any> {
    const requestUrl = this.settings.getConfig('client.url') + '/customer/religion';

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithToken());
  }

  getNationalityList(): Observable<any> {
    const requestUrl = this.settings.getConfig('client.url') + '/customer/nationality';

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithToken());
  }

  getCountryList(): Observable<any> {
    const requestUrl = this.settings.getConfig('client.url') + '/customer/country';

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithToken());
  }

  getProvince(param: Object): Observable<any> {
    const requestUrl = this.settings.getConfig('client.url') + '/customer/province/country';

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithToken());
  }

}
